import { Component, h, Host, Prop, EventEmitter, Event, Element } from '@stencil/core';

export type AlertVariant = 'success' | 'caution' | 'error' | 'notification';
export type AlertType = 'banner' | 'contextual';

@Component({
  tag: 'uui-alert',
  styleUrl: 'uui-alert.css',
  shadow: true
})
export class UUIBannerAlert {
  /** variant for banner */
  @Prop() variant: AlertVariant = 'notification';
  @Prop() type: AlertType = 'banner';
  @Prop() header: string;
  @Prop({ mutable: true, reflect: true }) visible: boolean = true;
  /** option to hide close button */
  @Prop({ mutable: true, reflect: true }) hideClose: boolean = false;
  @Event({ bubbles: true, composed: true }) close: EventEmitter;
  @Element() el: HTMLElement;

  hasHeaderSlot: boolean;

  onClose() {
    this.visible = false;
    this.close.emit();
  }

  componentWillLoad(): void {
    this.hasHeaderSlot = !!this.el.querySelector('[slot="header"]');
  }

  render() {
    const { variant, visible, header } = this;

    return (
      <Host role="alert" aria-hidden={visible ? 'false' : 'true'}>
        <div data-mode={variant}>
          <div class="alert-header-container">
            {!this.hasHeaderSlot ? (
              <p class="alert-header-text">{header}</p>
            ) : null}
            <slot name="header" />
            {!this.hideClose ? (
              <button
                onClick={this.onClose.bind(this)}
                class="uui-alert-header-close-btn"
              >
                <svg
                  height="20px"
                  width="20px"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" />
                </svg>
              </button>
            ) : null}
          </div>
          <div>
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
